import React from "react";
import * as IndexStyles from "../index.module.scss";
import { StaticImage } from "gatsby-plugin-image";

const Sidebar: React.FC = () => {
    return (
        <div className="position-relative text-center">
            <a href="/brewhouse/events">
                <StaticImage src="./assets/calendar.jpg" alt="The Brew House Calendar" />
            </a>
            <img src="/images/hr.png" className="my-5 mx-auto d-block" alt="Divider" />
            <div className="sans-serif">
                <h3 className="fs-5 fw-bold text-uppercase">Brew House Hours</h3>
                <p className="fs-5 text-info">
                    <span className="d-block mb-4">
                        <strong>Monday - Thursday</strong>
                        <br />
                        11am–10pm
                    </span>
                    <span className="d-block my-4">
                        <strong>Friday & Saturday</strong>
                        <br />
                        11am–11pm
                    </span>
                    <span className="d-block my-4">
                        <strong>Sunday</strong>
                        <br />
                        11am–10pm
                    </span>
                </p>
                <img src="/images/hr.png" className="my-5 mx-auto d-block" alt="Divider" />
                <h3 className="fs-5 fw-bold text-uppercase">Tasting Room</h3>
                <p className="fs-5 text-info">
                    <span className="d-block mb-4">
                        <strong>Monday - Thursday</strong>
                        <br />
                        11am&ndash;10pm
                    </span>
                    <span className="d-block my-4">
                        <strong>Friday & Saturday</strong>
                        <br />
                        11am&ndash;11pm
                    </span>
                    <span className="d-block my-4">
                        <strong>Sunday</strong>
                        <br />
                        11am&ndash;10pm
                    </span>
                </p>
                <img src="/images/hr.png" className="my-5 mx-auto d-block" alt="Divider" />
                <h3 className="fs-5 fw-bold text-uppercase">Brew House Address</h3>
                <p className="fs-5 fw-light">
                    25 Cataract St.
                    <br />
                    Rochester, NY 14605
                    <br />
                    <a href="tel:5852639200" className="text-info">
                        (585) 263-9200
                    </a>
                </p>
            </div>
            <ul className={IndexStyles.brewhouseNav}>
                <li>
                    <a href="/brewhouse/tour/">Tours & Tastings</a>
                </li>
                <li>
                    <a href="/brewhouse/menu/">Restaurant & Bar</a>
                </li>
                <li>
                    <a href="/brewhouse/whatsontap/">What&rsquo;s On Tap</a>
                </li>
                <li>
                    <a href="/brewhouse/privateevents/">Private Events</a>
                </li>
                <li>
                    <a href="/brewhouse/events/">Calendar</a>
                </li>
                <li>
                    <a href="https://store.geneseebeer.com/" target="_blank" rel="noopener">
                        Gift Shop
                    </a>
                </li>
                <li>
                    <a href="/brewhouse/">About</a>
                </li>
                <li>
                    <a href="/brewhouse/story/">Story</a>
                </li>
                <li>
                    <a href="/brewhouse/contact/">Contact</a>
                </li>
            </ul>
        </div>
    );
};

export default Sidebar;
